var map = {
	"./Adidas.png": "7f09",
	"./Adspin.png": "08eb",
	"./Avida.png": "a00d",
	"./Ayala-Malls.png": "8442",
	"./BBPB.png": "3c57",
	"./Bayanihan-Para-Sa-Magsasaka.png": "fdae",
	"./Called-To-Rescue.png": "9fa3",
	"./Digital-Spin.png": "85f7",
	"./Eco-Explorations.png": "5a9b",
	"./For-the-Future.png": "8458",
	"./GSM.png": "caf6",
	"./Green-Sun.png": "d5b3",
	"./Kids-Who-Farm.png": "177b",
	"./Lokal-Lab.png": "4a9d",
	"./MUNI-PH.png": "632f",
	"./Museo-Pambata.png": "0d3c",
	"./PLDT-Smart.png": "aa86",
	"./Philippine-Parks.png": "dee7",
	"./SDSN Youth Logo (1).png": "e42a",
	"./SDSN.png": "f690",
	"./Stages-Sessions.png": "41a4",
	"./Tamaraw-Society.png": "94c3",
	"./Taya-Pinas.png": "6e9c",
	"./Tukod.png": "7cfd",
	"./UNICEF-Philippines.png": "b22d",
	"./WWF.png": "74f9",
	"./Where-To-Next.png": "1ef3",
	"./Youthtopia.png": "5c70"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "e391";